import src from "IMAGE";
export default { src, width: 124, height: 30, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AFlU2eBqZt/pa2ff6WZi3+lqZt/paGTf6WRg3ulmZdHSAGRg7/iBffX/i4f2/4iE9f+BffX/iYb2/4SA9f9YVNrhXJwrRyz7gJgAAAAASUVORK5CYII="};
